import { render, staticRenderFns } from "./teacherCheck.vue?vue&type=template&id=c6af6bfe&"
import script from "./teacherCheck.vue?vue&type=script&lang=js&"
export * from "./teacherCheck.vue?vue&type=script&lang=js&"
import style0 from "./teacherCheck.vue?vue&type=style&index=0&id=c6af6bfe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports